import { render, staticRenderFns } from "./SelectLang.vue?vue&type=template&id=d04ab700"
import script from "./SelectLang.vue?vue&type=script&lang=js"
export * from "./SelectLang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports